<template>
  <div class="form-group">
    <label class="form-label">Событие*</label>
    <CustomSelect name="event" @initialize="onEventSelectInitialize" @itemSelected="onEventSelectItemSelected">
      <option value="DamageToPurchase">Утрата/ущерб покупки</option>
    </CustomSelect>
  </div>

  <div class="form-group">
    <label class="form-label">Причина события</label>
    <CustomSelect name="cause" @initialize="onEventCauseSelectInitialize" @itemSelected="onEventCauseSelectItemSelected">
      <option value="Fire">Пожар</option>
      <option value="Explosion">Взрыв</option>
      <option value="Flood">Залив</option>
      <option value="Disaster">Стихийное бедствие</option>
      <option value="PlaneCrash">Крушение самолета</option>
      <option value="Robbery">Грабеж</option>
      <option value="Brigandage">Разбой</option>
      <option value="Theft">Кража</option>
      <option value="RoadTrafficDamage">Ущерб в результате ДТП</option>
    </CustomSelect>
  </div>

  <div class="form-group">
    <label class="form-label">Что именно произошло (дополнительные комментарии к событию)</label>
    <textarea name="comments" class="form-textarea" rows="6" v-model="comments"></textarea>
  </div>

  <ContractInfoApplicant/>
</template>

<script>
import ContractInfoApplicant from "@/components/insurances/shared/ContractInfoApplicant";
import * as mns from "@/store/mutation-types";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "PurchaseProtection",
  components: {CustomSelect, ContractInfoApplicant},
  methods: {
    onEventSelectInitialize(event){
      this.$store.commit(mns.SET_EVENT, event.getValue().value);
    },
    onEventSelectItemSelected(event){
      this.$store.commit(mns.SET_EVENT, event.detail.choice.value);
    },
    onEventCauseSelectInitialize(event){
      this.$store.commit(mns.SET_CAUSE, event.getValue().value);
    },
    onEventCauseSelectItemSelected(event){
      this.$store.commit(mns.SET_CAUSE, event.detail.choice.value);
    },
  },
  computed: {
    comments: {
      get(){
        return this.$store.getters.comments;
      },
      set(value){
        this.$store.commit(mns.SET_COMMENTS, value);
      }
    }
  }
}
</script>

<style scoped>

</style>